import { ModelSagres } from "../../model-sagres"

/**
 * Este modelo é utilizado na página onde um documento é preenchido e enviado para a API. 
 * Data a natureza como estas prestações foram modeladas em nosso BD, esta entidade difere da entidade que 
 * exibe um documento já cadastrado.
 * 
 * @since 20220728
 */
export class EntregaDocumentoDto extends ModelSagres {    
    idTipoLegislacao: number
    idTipoAto: number
    numeroDoc: number
    anoDoc: number
    publicacaoAto: Date
    inicioVigencia: Date
    vlPrefeito: number
    vlVicePrefeito: number
    vlVereador: number
    qtdVereadores: number
    arquivo: File
}